const link = '`https://dashboard.stripe.com/test/payments`';
const error = '`Payment failed ${payload.error.message}`';

export default ({
  demo,
  server,
}) => `import React, { useState, useEffect } from "react";
import {
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

export default function CheckoutForm() {
  {+init-state}
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState('');
  {?email email-state}
  const [email, setEmail] = useState('');
  {/email-state}
  {/init-state}
  {+use-stripe}
  const stripe = useStripe();
  const elements = useElements();
  {/use-stripe}

  {+fetch-secret}
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    window
      .fetch(${
        server === 'php' ? '"/create.php"' : '"/create-payment-intent"'
      }, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({items: [{ id: "xl-tshirt" }]})
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        setClientSecret(data.clientSecret);
      });
  }, []);
  {/fetch-secret}

  {+style-element input}
  const cardStyle = {
    style: {
      base: {
        color: {span animate cardText}"${demo.cardText}"{/span},
        fontFamily: {span animate cardFont}'${demo.cardFont}'{/span},
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: {span animate cardText}"${demo.cardText}"{/span}
        }
      },
      invalid: {
        color: "${demo.cardInvalid}",
        iconColor: "${demo.cardInvalid}"
      }
    }
  };
  {/style-element}

  {+listen-for-change}
  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };
  {/listen-for-change}

  const handleSubmit = async ev => {
    ev.preventDefault();
    setProcessing(true);

    {+complete-payment}
    const payload = await stripe.confirmCardPayment(clientSecret, {
      {?email email-1}
      receipt_email: email,
      {/email-1}
      payment_method: {
        card: elements.getElement(CardElement)
      }
    });
    {/complete-payment}

    if (payload.error) {
      setError(${error});
      setProcessing(false);
    } else {
      setError(null);
      setProcessing(false);
      setSucceeded(true);
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {?email email-0}
      <input
        type="text"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter email address"
      />
      {/email-0}
      {+render-input}
      <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
      {/render-input}
      <button
        disabled={processing || disabled || succeeded}
        id="submit"
      >
        <span id="button-text">
          {processing ? (
            <div className="spinner" id="spinner"></div>
          ) : (
            "Pay now"
          )}
        </span>
      </button>
      {+handle-error}
      {/* Show any error that happens when processing the payment */}
      {error && (
        <div className="card-error" role="alert">
          {error}
        </div>
      )}
      {/handle-error}
      {+success}
      {/* Show a success message upon completion */}
      <p className={succeeded ? "result-message" : "result-message hidden"}>
        Payment succeeded, see the result in your
        <a
          href={${link}}
        >
          {" "}
          Stripe dashboard.
        </a> Refresh the page to pay again.
      </p>
      {/success}
    </form>
  );
}
`;
